import { supabase } from '../lib/supabase'
import type { DbSubscription, PlanTier } from '../types'

export async function getSubscription(userId: string, householdId?: string | null): Promise<DbSubscription | null> {
  const { data, error } = await supabase
    .from('subscriptions')
    .select('*')
    .eq('user_id', userId)
    .eq('status', 'authorized')
    .order('created_at', { ascending: false })
    .limit(1)
    .maybeSingle()

  if (error) throw error
  if (data) return data as DbSubscription

  // Guest/partner: fall back to the household's active subscription
  if (householdId) {
    const { data: householdSub, error: hErr } = await supabase
      .from('subscriptions')
      .select('*')
      .eq('household_id', householdId)
      .eq('status', 'authorized')
      .order('created_at', { ascending: false })
      .limit(1)
      .maybeSingle()

    if (hErr) throw hErr
    return (householdSub as DbSubscription | null)
  }

  return null
}

export async function startUpgrade(params: {
  userId: string
  householdId: string | null
  planTier: Exclude<PlanTier, 'free'>
  billingCycle: 'monthly' | 'annual'
  payerEmail: string
}): Promise<void> {
  const res = await supabase.functions.invoke('create-subscription', { body: params })
  if (res.error) throw new Error(res.error.message)

  const { initPoint } = res.data as { initPoint: string; subscriptionId: string }
  window.location.href = initPoint
}

export async function cancelSubscription(subscriptionId: string, userId: string): Promise<void> {
  const res = await supabase.functions.invoke('cancel-subscription', {
    body: { subscriptionId, userId },
  })
  if (res.error) throw new Error(res.error.message)
}
